import V from 'voUtils/V.js';

import {
	isBlank,
	objectIsSimilar
}
from 'voUtils/tools.js';

import {
	fireSearch
}
from 'voUtils/TagEx.js';

import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	getVoucher
}
from 'voUtils/VoucherStore.js';
import {
	getAbTest
}
from 'voUtils/AbTest.js';

import {
	getFavIds
}
from 'voUtils/FavStore.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';


export default {
	data: {
		mapItems: [{
			"_id": 1,
			"sectionid": "funhallaostseeresortdamp",
			"name": "Funhalla OstseeResort Damp - Schietwetter",
			"loc": {
				"coordinates": [10.021313431643392, 54.587556793774084]
			}
		}, {
			"_id": 2,
			"sectionid": "capitollichtspielekappeln",
			"name": "Capitol Lichtspiele Kappeln - Schietwetter",
			"loc": {
				"coordinates": [9.932604000000001, 54.661079726747104]
			}
		}, {
			"_id": 3,
			"sectionid": "keramikahoi",
			"name": "Keramik Ahoi - Schietwetter",
			"loc": {
				"coordinates": [9.83435597668674, 54.47279859819124]
			}
		}, {
			"_id": 4,
			"sectionid": "ucikinoflensburg",
			"name": "UCI Kino Flensburg - Schietwetter",
			"loc": {
				"coordinates": [9.437075329447788, 54.785322766696375]
			}
		}, {
			"_id": 5,
			"sectionid": "seehundstationfriedrichskoog",
			"name": "Seehundstation Friedrichskoog - Schietwetter",
			"loc": {
				"coordinates": [8.87671701165663, 54.000913473840335]
			}
		}, {
			"_id": 6,
			"sectionid": "phanomentainflensburg",
			"name": "Phänomenta in Flensburg - Schietwetter",
			"loc": {
				"coordinates": [9.430046457670718, 54.795433496439536]
			}
		}, {
			"_id": 7,
			"sectionid": "entdeckerbadimostseeresortdamp",
			"name": "Entdeckerbad im OstseeResort Damp - Schietwetter",
			"loc": {
				"coordinates": [10.02328465889558, 54.58818396529632]
			}
		}, {
			"_id": 8,
			"sectionid": "meerwasserwellenbadeckernforde",
			"name": "Meerwasser Wellenbad Eckernförde - Schietwetter",
			"loc": {
				"coordinates": [9.83972831779116, 54.46512237906481]
			}
		}, {
			"_id": 9,
			"sectionid": "mediendomkiel",
			"name": "Mediendom Kiel - Schietwetter",
			"loc": {
				"coordinates": [10.181188790180663, 54.33234093110644]
			}
		}, {
			"_id": 10,
			"sectionid": "aquariumimostseeinfocentereckernforde",
			"name": "Aquarium im Ostsee-Info-Center Eckernförde - Schietwetter",
			"loc": {
				"coordinates": [9.84120968220884, 54.473148208478776]
			}
		}, {
			"_id": 11,
			"sectionid": "fordelandthermeglucksburg",
			"name": "Fördeland Therme Glücksburg - Schietwetter",
			"loc": {
				"coordinates": [9.533536682208839, 54.8373689164966]
			}
		}, {
			"_id": 12,
			"sectionid": "schlaefkesschokoladenkuchekappeln",
			"name": "Schlaefkes Schokoladenküche Kappeln - Schietwetter",
			"loc": {
				"coordinates": [9.92847367055221, 54.66147641822263]
			}
		}],
	},
	beforeMount: function () {

	},
	updated: function () {

	},
	computed: {

	},
	watch: {

	}

};